// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2ND39","headWrap":"_3eVdr","detail":"_337R4","automatically":"_1xpjS","verticalAlign":"iphlo"};